import { Col, Row } from 'react-bootstrap';
import { DashboardContractCard } from './components/DashboardContractCard';
import { DashboardLinkedCampaignCard } from './components/DashboardLinkedCampaignCard';
import { useLongTermDashboard } from './hook/useLongTermDashboard';
import { DashboardRightSide } from './components/DashboardRightSide';
import { shallowEqual, useSelector } from 'react-redux';
import { IAllStates } from '../../../../store/rootReducer';
import { CampaignDiscoveryCard } from '../dashboard/components/CampaignDiscoveryCard';
import { hasAccessRights } from '../../../../shared/functions/Functions';
import { AccessRightEnum } from '../../../../enum/AccessRightEnum';
import { LongTermDashboardSkeleton } from './components/LongTermDashboardSkeletons';

export default function LongTermDashboard() {
    const {
        campaigns,
        contracts,
        contractsInfo,
        managementInfo,
        setUpdateManagement,
        supervisors,
        filterContracts,
        setFilterContracts,
        contractsCount,
        campaignCount,
        filterChildCampaigns,
        setFilterChildCampaigns,
        isContractsLoading,
        isCampaignsLoading,
        isManagementLoading,
        isSupervisorsLoading,
    } = useLongTermDashboard();
    const { isAclLoaded } = useSelector((state: IAllStates) => state.selectedCampaign, shallowEqual);

    if (!isAclLoaded) {
        return <LongTermDashboardSkeleton />;
    }

    return (
        <Row className="flex-column-reverse flex-md-row">
            <Col md={12} lg={8}>
                {hasAccessRights(AccessRightEnum.CAN_VIEW_DISCOVERY) && <CampaignDiscoveryCard />}
                <DashboardContractCard
                    contracts={contracts}
                    contractsInfo={contractsInfo}
                    filterParams={filterContracts}
                    setFilterParams={setFilterContracts}
                    contractCount={contractsCount}
                    isLoading={isContractsLoading}
                />
                <DashboardLinkedCampaignCard
                    campaigns={campaigns}
                    filterParams={filterChildCampaigns}
                    setFilterParams={setFilterChildCampaigns}
                    campaignCount={campaignCount}
                    isLoading={isCampaignsLoading}
                />
            </Col>
            <Col md={12} lg={4}>
                <DashboardRightSide
                    info={managementInfo}
                    setUpdate={setUpdateManagement}
                    supervisors={supervisors}
                    isManagementLoading={isManagementLoading}
                    isSupervisorsLoading={isSupervisorsLoading}
                />
            </Col>
        </Row>
    );
}
